document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-question").forEach(function (question) {
    question.addEventListener("click", function () {
      const targetId = this.getAttribute("data-target");
      const answer = document.getElementById(targetId);
      const icon = this.querySelector(".faq-icon");
      if (answer) {
        const visible = answer.style.display === "block";
        answer.style.display = visible ? "none" : "block";
        if (icon) icon.textContent = visible ? "+" : "−";
      }
    });
  });
});
